var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{on:{"click":_vm.shooseImage}},[_vm._v("请在手机浏览器中打开此站点！")]),_c('div',[_vm._v(_vm._s(_vm.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }